module.exports = __webpack_public_path__ + "img/ball_0_orange.75ee2f5a.png";